import React from "react";
import s from '../css/card.module.css'

export default function Card({id, name, weight, weight_Min, weight_Max, temperament,life_span, temperaments,createdInDb, image}){
    return(
        <div className={s.contenedor}>
            <div className={s.conten2}>
                <h3>{id}</h3>
                <h3 className={s.h3} >{name}</h3>
                {!image?<img className={s.image} src={'https://www.sogarca.com/wp-content/uploads/2015/06/No-disponible.jpg'}/>:<img className={s.image} src={image} alt="img not found"/>}
                <h3> Temperaments</h3>
                <p>{!createdInDb?temperaments+'  ':temperaments.map(b=>b+(' , '))}</p>
                <h3>Weight Min-Max:</h3>
                <h4>{weight_Min} - {weight_Max} Kg</h4>
            </div>
        </div>
    )
}


